import { createContext, useContext } from 'react';
import { type MapRef, useMap as useReactGLMap } from 'react-map-gl/mapbox';
import { mapId as defaultMapId } from '../utils/constants';

/**
 * The map components resolve to when they don't name one. Only provided by trees that render map
 * components on a secondary map instance (the print preview), so pages that have a single map keep
 * resolving to it without every component threading a map id through.
 */
const MapIdContext = createContext<string | undefined>(undefined);

export const MapIdProvider = MapIdContext.Provider;

export default function useMap(mapId?: string): MapRef | undefined {
  const contextMapId = useContext(MapIdContext);
  const { [mapId ?? contextMapId ?? defaultMapId]: map } = useReactGLMap();

  return map;
}
